'use strict';
export const sep = '/';

export const versao:string = "1.00.10";

// teste
export const servidorLocalPaulo:string = "https://www.diviprev.mg.gov.br/controladores/controler2.php";
export const servidorCensoSite: string = "https://app.diviprev.mg.gov.br/controller/controler.php";
 

//export const servidorLocalPaulo:string = "http://localhost/controladores/controler2.php";

export const traducaoCalendar:any  = {
    firstDayOfWeek: 0,
    dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
    dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
    monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho',
      'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };








